import { MouseEvent } from 'react';
import { TicketIcon } from '@kursk/components/ui/icons';
import { hintsHash } from '@kursk/components/ui/BuyButton/getButtonProps';
import { IMovie } from "@common/redux/types/movie";

import classNames from 'classnames';
import style from "@kursk/components/ui/BuyButton/BuyButton.module.scss";

interface IProps {
  movie: IMovie;
  onClick: () => void;
}

export function MovieHeaderButton({ movie, onClick }: IProps) {
  const isPushkin = Boolean(movie.events?.find((event) => event.source?.meta?.pushkin));
  const hint = isPushkin ? hintsHash.pushkinCard() : '';

  const onButtonClick = (event: MouseEvent) => {
    event.preventDefault();
    onClick();
  }

  return (
    <>
      <div className={style.buyButton__wrapper}>
        <button
          className={style.buyButton__button}
          onClick={onButtonClick}
        >
          <div className={style.buyButton__button__icon}>
            <TicketIcon/>
          </div>
          <div className={style.buyButton__button__separator}/>
          <div className={style.buyButton__button__content}>
            <div className={style.buyButton__button__text}>
              Посмотреть расписание
            </div>
          </div>
        </button>
        {!!hint && (
          <div className={classNames(style.buyButton__hint, style.buyButton__hint_dark)}>
            {hint}
          </div>
        )}
      </div>
    </>
  );
}
